import './styles/index.css'
import './i18n'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import Home from './pages/Home'
import PWAInstall from './components/PWAInstall'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Home />
    <PWAInstall />
  </StrictMode>
)
